// Tiny CSV helpers — no external dependency.
// Handles quoted fields, escaped quotes ("") and newlines inside quoted fields.

const escapeField = (v) => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (/[",\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
};

export const buildCSV = (columns, rows) => {
  const head = columns.map(c => escapeField(c.label || c.key)).join(',');
  const body = rows.map(r => columns.map(c => {
    const v = typeof c.get === 'function' ? c.get(r) : r[c.key];
    return escapeField(v);
  }).join(',')).join('\n');
  return head + '\n' + body;
};

export const downloadCSV = (filename, columns, rows) => {
  const csv = buildCSV(columns, rows);
  // BOM so Excel/Sheets opens UTF-8 cleanly (important for አማርኛ / ትግርኛ)
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Parse CSV text into an array of row-objects keyed by header.
// Rows with a leading "#" or empty rows are skipped.
export const parseCSV = (text) => {
  if (!text) return [];
  // Strip BOM if present
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
  const rows = [];
  let i = 0, field = '', row = [], inQuote = false;
  const len = text.length;
  while (i < len) {
    const ch = text[i];
    if (inQuote) {
      if (ch === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuote = false; i++; continue;
      }
      field += ch; i++; continue;
    }
    if (ch === '"') { inQuote = true; i++; continue; }
    if (ch === ',') { row.push(field); field = ''; i++; continue; }
    if (ch === '\r') { i++; continue; }
    if (ch === '\n') { row.push(field); field = ''; rows.push(row); row = []; i++; continue; }
    field += ch; i++;
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  // First row = headers
  if (!rows.length) return [];
  const headers = rows[0].map(h => h.trim());
  return rows.slice(1)
    .filter(r => r.some(c => String(c).trim() !== '') && !(r[0] || '').startsWith('#'))
    .map(r => Object.fromEntries(headers.map((h, idx) => [h, (r[idx] ?? '').trim()])));
};

export const readFileAsText = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file, 'utf-8');
  });
